import $ from 'cash-dom'
import SliderController from './slider-controller'
import Splide from '@splidejs/splide'

export default class StoryCards {
  constructor({ $container } = {}) {
    this.$container = $container
    this.splide = null

    this.constructElements()

    this.constructSplide()
  }

  static init() {
    const $containers = $(StoryCards.selectors.container)

    if ($containers.length) {
      $containers.each((i, elem) => {
        const constructed = new StoryCards({ $container: $(elem) })
      })
    }
  }

  constructElements() {
    this.$splide = this.$container.find('.splide')
  }

  constructSplide() {
    if(!this.$splide[0]) return;
    this.splide = new Splide(this.$splide[0], {
      arrows: false,
      gap: 20,
      mediaQuery: 'min',
      pagination: false,
      perPage: 1,
      type: 'loop',

      breakpoints: {
        '768': {
          gap: 32,
          perPage: 2,
        },
        '1024': {
          perPage: 3,
        },
      }
    }).mount()

    this.splideController = new SliderController({
      $container: this.$container,
      splide: this.splide
    })
  }
}

StoryCards.selectors = {
  container: '.js-story-cards',
}
